module.exports = __webpack_public_path__ + "img/9788996100157.b00633c7.jpg";